/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_CenterInputs */

const en_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center`)
};

const fr_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre`)
};

const de_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center`)
};

const it_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

const ru_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центр`)
};

const es_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

const zh_cn2_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中心`)
};

const ja_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中心`)
};

const hi_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र`)
};

const pt_pt2_input_position_x_center = /** @type {(inputs: Input_Position_X_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro`)
};

/**
* | output |
* | --- |
* | "Center" |
*
* @param {Input_Position_X_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_center = /** @type {((inputs?: Input_Position_X_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_x_center(inputs)
	if (locale === "de") return de_input_position_x_center(inputs)
	if (locale === "it") return it_input_position_x_center(inputs)
	if (locale === "ru") return ru_input_position_x_center(inputs)
	if (locale === "es") return es_input_position_x_center(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_x_center(inputs)
	if (locale === "ja") return ja_input_position_x_center(inputs)
	if (locale === "hi") return hi_input_position_x_center(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_x_center(inputs)
	return en_input_position_x_center(inputs)
});